module.exports = __webpack_public_path__ + "media/images/pages/solutions/automation/questionnaire_design-4a2c3adf107b10e5bd0633ca7a1da3a9.png";